module.exports = __webpack_public_path__ + "img/good.2e757a44.png";